import { render, staticRenderFns } from "./specifyInventory.vue?vue&type=template&id=6527ebf0&scoped=true"
import script from "./specifyInventory.vue?vue&type=script&lang=ts"
export * from "./specifyInventory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527ebf0",
  null
  
)

export default component.exports